import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator } from "./ui/dropdown-menu";
import { MoveRight } from "lucide-react";

// Generic pipeline board. stages: [{key,label}], items with .stage, group by stage.
export const KanbanBoard = ({ stages, items, renderCard, onCardClick, onMove, accent = "#2540FF", cardAccent, extraMoves = [] }) => {
  const grouped = {};
  stages.forEach((s) => (grouped[s.key] = []));
  items.forEach((it) => {
    if (grouped[it.stage]) grouped[it.stage].push(it);
  });

  return (
    <div className="kanban-scroll overflow-x-auto pb-4 -mx-1">
      <div className="flex gap-4 px-1" style={{ minWidth: "max-content" }}>
        {stages.map((s) => (
          <div key={s.key} className="w-[280px] flex-shrink-0" data-testid={`kanban-stage-${s.key}`}>
            <div className="flex items-center justify-between mb-3 px-1">
              <div className="flex items-center gap-2">
                <span className="h-2.5 w-2.5 rounded-full" style={{ background: accent }} />
                <h3 className="text-sm font-semibold text-slate-700 font-head">{s.label}</h3>
              </div>
              <span className="text-xs font-semibold text-slate-500 bg-slate-100 px-2 py-0.5 rounded-full">
                {grouped[s.key].length}
              </span>
            </div>
            <div className="col-scroll space-y-3 max-h-[calc(100vh-260px)] overflow-y-auto pr-1">
              {grouped[s.key].map((it) => (
                <div
                  key={it._id}
                  data-testid={`kanban-card-${it._id}`}
                  className="card-hover bg-white rounded-xl border border-slate-200 p-3.5 cursor-pointer"
                  style={cardAccent ? { borderLeft: `4px solid ${cardAccent(it)}` } : undefined}
                  onClick={() => onCardClick(it)}
                >
                  {renderCard(it)}
                  <div className="mt-3 pt-2.5 border-t border-slate-100 flex justify-end" onClick={(e) => e.stopPropagation()}>
                    <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <button
                          data-testid={`move-card-${it._id}`}
                          className="text-[11px] font-medium text-ccc-blue hover:text-ccc-blue2 flex items-center gap-1"
                        >
                          Move <MoveRight className="h-3 w-3" />
                        </button>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent align="end">
                        <DropdownMenuLabel>Move to stage</DropdownMenuLabel>
                        <DropdownMenuSeparator />
                        {stages
                          .filter((x) => x.key !== it.stage)
                          .map((x) => (
                            <DropdownMenuItem
                              key={x.key}
                              data-testid={`move-to-${x.key}-${it._id}`}
                              onClick={() => onMove(it, x.key)}
                            >
                              {x.label}
                            </DropdownMenuItem>
                          ))}
                        {extraMoves.length > 0 && <DropdownMenuSeparator />}
                        {extraMoves.filter((x) => x.key !== it.stage).map((x) => (
                          <DropdownMenuItem key={x.key} data-testid={`move-to-${x.key}-${it._id}`} onClick={() => onMove(it, x.key)} className="text-ccc-rose">
                            {x.label}
                          </DropdownMenuItem>
                        ))}
                      </DropdownMenuContent>
                    </DropdownMenu>
                  </div>
                </div>
              ))}
              {grouped[s.key].length === 0 && (
                <div className="text-xs text-slate-400 text-center py-6 border border-dashed border-slate-200 rounded-xl">
                  Empty
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
